import React, {Component} from "react";
import BaseComponent from "../base";
import Field from "../common/Field";
import i18 from "../../i18";
import Validator from "../common/Validator";
import api from "../../source/api";
import NotificationSystem from "react-notification-system";

class BankTestInput extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            processing: false,
            fields: {
                bankFile: {value: "", error: "", role: {required: true}},
                extra_files: {value: [], error: "", role: {required: false}},
            },
            error: null,
            items: null, // kezdetben null
            totals: null, // kezdetben null
        };
    }

    _addNotification = (msg, type, time = 4) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: "tc",
            autoDismiss: time,
        });
    };

    upload = () => {
        const validator = Validator.validate(this.state.fields);

        this.setState({
            fields: validator.fields,
            error: validator.error,
        });

        if (validator.error) {
            return;
        }

        document.body.classList.add("loading-body");
        this.setState({processing: true});

        api
            .postFile({url: "bank/test-input", data: this.collectFormData()}, true)
            .then((response) => {
                if (response.status === 200) {
                    this.setState({
                        processing: false,
                        items: response.data.data.bankItems,
                        totals: response.data.data.totals,
                    });
                }
                document.body.classList.remove("loading-body");
            })
            .catch((err) => {
                document.body.classList.remove("loading-body");
                this.setState({processing: false, items: null, totals: null});
                this._addNotification(
                    (err.response && err.response.data && err.response.data.error) || "Hiba történt a feltöltéskor.",
                    "error"
                );
            });
    };

    collectFormData = () => {
        const form = new FormData();
        const bankFile = this.state.fields.bankFile.value;
        if (bankFile) {
            form.append("bankStatementFile", bankFile);
        }

        const extraFiles = Array.from(this.state.fields.extra_files.value || []);

        extraFiles.forEach((file, index) => {
            form.append(`extra_files[${index}]`, file);
        });

        return form;
    };

    setValue = (name, value, error) => {
        this.setState((prevState) => ({
            fields: {
                ...prevState.fields,
                [name]: {
                    ...prevState.fields[name],
                    value,
                    error,
                },
            },
        }));
    };

    render() {
        const {fields, processing, items} = this.state;
        const formatNumber = (number) => {
            return new Intl.NumberFormat('hu-HU', {
                style: 'currency',
                currency: 'HUF',
                minimumFractionDigits: 0
            }).format(number);
        };

        return (
            <section id="bank-takarek-bank-replacer" className="my-5">
                <div className="container">
                    <div className="header">
                        <h1>
                            Bankszámlakivonat feldolgozó
                        </h1>
                        <p>
                            Ezzel a modullal lehet ellenőrizni, hogy a Beeker hogyan fogja
                            értelmezni a beküldött bankszámlakivonatot.
                        </p>
                    </div>

                    <div className="row">
                        <div className="col-md-10 offset-md-2 my-5">
                            <table className="table table-bordered">
                                <thead>
                                <tr>
                                    <th>Megnevezés</th>
                                    <th>Banki kivonat (kötelező)</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        Bank számlakivonat file
                                    </td>
                                    <td>
                                        <Field
                                            type="file"
                                            id="bankFile"
                                            name="bankFile"
                                            classLabel="control-label"
                                            classInput="file-input"
                                            setValue={this.setValue}
                                            state={this.state}
                                        />
                                    </td>

                                </tr>
                                <tr>
                                    <td>Gyűjtő számlák (GLS, MPL, SimplePay)</td>
                                    <td>
                                        <Field
                                            type="file"
                                            id="extra_files"
                                            name="extra_files"
                                            classLabel="control-label"
                                            classInput="file-input"
                                            setValue={this.setValue}
                                            state={this.state}
                                            multiple
                                        />
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>

                    <div className="next-step-btn-container text-center">
                        <button
                            onClick={this.upload}
                            className={`next-step ${processing ? "disabled" : ""}`}
                            disabled={processing}
                        >
                            {processing ? "Betöltés..." : "Betöltés"}
                        </button>
                    </div>
                </div>

                {items && (
                    <div className="container-fluid">
                        {/* Totals szekció */}
                        <div className="mb-4 p-3 border rounded bg-light">
                            <h5 className="mb-3">Összesített adatok</h5>
                            <ul className="list-unstyled mb-0">
                                <li>
                                    <strong>Tranzakciók száma:</strong> {this.state.totals.countOfItems}
                                </li>
                                <li>
                                    <strong>Pozitív összeg:</strong>
                                    <span className="text-success"> {formatNumber(this.state.totals.positiveSum)}</span>
                                </li>
                                <li>
                                    <strong>Negatív összeg:</strong>
                                    <span className="text-danger"> {formatNumber(this.state.totals.negativeSum)}</span>
                                </li>
                                <li>
                                    <strong>Összesített egyenleg:</strong>
                                    <span className={this.state.totals.sumOfItems >= 0 ? "text-success" : "text-danger"}>
                        {formatNumber(this.state.totals.sumOfItems)}
                    </span>
                                </li>
                            </ul>
                        </div>

                        {/* Bank tételek táblázat */}
                        <table className="table table-striped mt-5">
                            <thead>
                            <tr>
                                <th>ID</th>
                                <th>Nap</th>
                                <th>Tranzakció típusa</th>
                                <th>Partner</th>
                                <th>Partner bankszámla száma</th>
                                <th>Összeg</th>
                                <th>Deviza</th>
                                <th>Megjegyzés</th>
                            </tr>
                            </thead>
                            <tbody>
                            {items.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.id}</td>
                                    <td>{item.day}</td>
                                    <td>{item.typeOfTraffic}</td>
                                    <td>{item.companyName}</td>
                                    <td>{item.invoiceNumber}</td>
                                    <td>{item.sum}</td>
                                    <td>{item.currency}</td>
                                    <td>{item.announcement}</td>
                                </tr>
                            ))}
                            </tbody>
                            <tfoot>
                            <tr className="font-weight-bold">
                                <td colSpan="5"></td>
                                <td>
                                    {items.reduce((total, item) => total + item.sum, 0)}
                                </td>
                                <td colSpan="2"></td>
                            </tr>
                            </tfoot>

                        </table>
                    </div>
                )}

                <NotificationSystem ref="notificationSystem"/>
            </section>
        );
    }
}

export default BankTestInput;



// WEBPACK FOOTER //
// ./src/components/bank/BankTestInput.js